import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { HeaderRow } from './header-row';
import { BodyRow } from './body-row';
import style from './style.module.less';
import { noop } from 'ui-components/default-props/noop';
import { emptyArray } from 'ui-components/default-props/empty';
import { AllErrorsResolvedRow } from './all-resolved-row';
import { ZeroRecordsRow } from './zero-records-row';
import { errorWarnPropType } from '../error-warn-propType';

export const DataTable = ({
  errorOrWarnCollection = emptyArray,
  onRowSelected = noop,
  onToggleAllChecked = noop,
  hasToggleAllChecked = false,
  className,
  closeModal = noop,
  allRemoved = false,
  opensFromLabelQue = false,
  showActionableColumns = true,
  showReadyToPickTableLayout = false,
  batchId,
  onRemoveRow,
  showSkuCell,
}) => {
  const topLevelClassName = classnames(style['error-or-warn-data-table'], {
    [style['two-columns']]: !showActionableColumns,
    [style['four-columns']]: showActionableColumns,
    [style['five-columns']]: showSkuCell || showReadyToPickTableLayout,
  });
  return (
    <div className={classnames(topLevelClassName, className)}>
      <HeaderRow
        hasToggleAllChecked={hasToggleAllChecked}
        onToggleAllChecked={onToggleAllChecked}
        showActionableColumns={showActionableColumns}
        showReadyToPickTableLayout={showReadyToPickTableLayout}
        showSkuCell={showSkuCell}
      />
      {allRemoved && <ZeroRecordsRow />}
      {!allRemoved && errorOrWarnCollection.length === 0 && <AllErrorsResolvedRow />}
      {errorOrWarnCollection.map((item) => {
        return (
          <BodyRow
            key={item.id}
            batchId={batchId}
            closeModal={closeModal}
            fulfillmentPlanId={item.fulfillmentPlanId}
            id={item.id}
            isSelected={item.isSelected}
            isWarning={item.isWarning}
            messages={item.messages}
            messageType={item.message?.props?.description === 'bulkErrorsAndWarningsService.activeLabel' ? 'activeLabelWarning' : item.type}
            name={item.name}
            onRemoveRow={onRemoveRow}
            onRowSelected={onRowSelected}
            opensFromLabelQue={opensFromLabelQue}
            orderDate={item.orderDate}
            orderNumber={item.salesOrderNumber}
            problemDescription={item.problemDescription}
            productId={item.productId}
            showActionableColumns={showActionableColumns}
            showReadyToPickTableLayout={showReadyToPickTableLayout}
            sku={item.sku}
          />
        );
      })}
    </div>
  );
};

DataTable.propTypes = {
  errorOrWarnCollection: errorWarnPropType,
  onRowSelected: PropTypes.func,
  onToggleAllChecked: PropTypes.func,
  hasToggleAllChecked: PropTypes.bool,
  closeModal: PropTypes.func,
  allRemoved: PropTypes.bool,
  opensFromLabelQue: PropTypes.bool,
  showActionableColumns: PropTypes.bool,
  showReadyToPickTableLayout: PropTypes.bool,
  batchId: PropTypes.string,
  className: PropTypes.string,
  onRemoveRow: PropTypes.func.isRequired,
};
